import { render, staticRenderFns } from "./_author.vue?vue&type=template&id=65008ca0"
import script from "./_author.vue?vue&type=script&lang=js"
export * from "./_author.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AuthorHeader: require('/app/app/components/author/Header/index.vue').default,AdvBanner: require('/app/app/components/adv/Banner/index.vue').default})
